var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"navbar-brand col-3 col-sm-3 col-md-2 mr-0 center",attrs:{"to":"/"}},[_c('img',{staticClass:"brand-image",attrs:{"src":require("@/assets/images/Sportlight-Logo-White.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }